import { render, staticRenderFns } from "./CompassItemRatio.vue?vue&type=template&id=9303b682&scoped=true&"
import script from "./CompassItemRatio.vue?vue&type=script&lang=ts&"
export * from "./CompassItemRatio.vue?vue&type=script&lang=ts&"
import style0 from "./CompassItemRatio.vue?vue&type=style&index=0&id=9303b682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9303b682",
  null
  
)

export default component.exports